export const next = (c) => String.fromCharCode(c.charCodeAt(0) + 1)
export const prev = (c) => String.fromCharCode(c.charCodeAt(0) - 1)
// export const getTheDate = (date) => date ? typeof date === 'string' ? new Date(date) : date.toDate() : ''
// export const countInArray = (array, what) => array.filter(item => item == what).length
export const hasUser = (id) => id.length > 21

export const getTheDate = (date) => date ? typeof date === 'string' ? new Date(date) : date.toDate() : ''